import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Input, LabelText, SubmitButton, FlexContainer, H1Text, Hr, Text, Img, InputWrapper, LeftBackButtonText } from "../../design";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { API } from "../../api";
import { COUNTRY_PHONE_CODE, PAGES } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import Select from 'react-select';
import NumberFormat from "react-number-format";
import { isValidPhoneNumber } from "libphonenumber-js";
import OpenIcon from "../../assets/imgs/eyeopen.svg";
import HiddenIcon from "../../assets/imgs/eyeclose.svg";

type Props = {
    history: {
        push: Function,
    },
}

const Login = (props: Props) => {
    const [errorMessage, setErrorMessage] = useState();
    const [success, setSuccess] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [mobileAuthentication, setMobileAuthentication] = useState(false);
    const [authenticatedMobile, setAuthenticatedMobile] = useState(null);
    const [otpRequestId, setOtpRequestId] = useState(null);

    const { handleSubmit, errors, control } = useForm();

    const onSubmit = async (data) => {
        setErrorMessage();
        const fullPhone = data?.phone && data?.countryCallingCode
        ? `${data.countryCallingCode.value}${data.phone || ""}`
        : "";
            try {
                if(!mobileAuthentication){
                    const { data: { responseCode, entity } } = await API.post('/rewards/auth/requestLogin', {
                        phoneNumber: fullPhone,
                    });
                    if (responseCode === 200) {
                        setAuthenticatedMobile(fullPhone);
                        setMobileAuthentication(true);
                        setOtpRequestId(entity?.otpRequestId);
                    }
                } else {
                    const { data: { responseCode, entity } } = await API.post('/rewards/auth/authenticate', {
                        phoneNumber: authenticatedMobile,
                        otpRequestId,
                        otp: data?.newpin
                    });
                    if (responseCode === 200) {
                        setSuccess(true);
                        localStorage.setItem("rtpAccessToken", entity?.token?.accessToken);
                    }
                }
            } catch (e) {
                setErrorMessage(e && e.data ? e?.data?.message : 'Unable to process request. Please try again later');
            }
    }

    useEffect(() => {
        if (success) {
            props.history.replace(PAGES.RTP_ADDED_BANKS);
        }
    }, [success]);

    const customInputStyle = {
        background: 'white',
        borderColor: '#CCCCCC',
        width: '100%',
        height: '41px',
        paddingLeft: '15px',
    };

    const isPhoneNumberValidate = (data: string) => {
    const cuntryCode = control.getValues().countryCallingCode.value;
    const phoneNum = control.getValues().phone;
    if (!isValidPhoneNumber(`${cuntryCode}${phoneNum}`)) {
        return 'The phone number is invalid';
    }
    };

    const phoneCustomStyles = {
    container: base => ({
      height: '41px',
      width: '100px !important'
      // maxWidth: '100px !important',
    }),
    control: base => ({
      ...base,
      height: '39px',
      minHeight: '39px',
      width: '100px !important',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important'
    }),
    };

    const customInputStylePin = {
        background: 'white',
        borderColor: '#CCCCCC',
        width: '90%',
        height: '41px',
        paddingLeft: '15px',
    };

    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        <LeftBackButtonText
                            onClick={() => { props.history.push(PAGES.RTP_REGISTER); }}
                        >
                            Back
                        </LeftBackButtonText>
                        <H1Text>
                            ACCOUNT REGISTER
                        </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                <FlexContainer
                    className="pt-3 pt-lg-5 w-100 p-2"
                    box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    display="flow-root"
                    backgroundColor="#fff"
                    borderRadius="10px"
                    marginTop="5%"
                    marginBottom="5%"
                >
                    <H1Text
                        className="px-1 px-md-4 mt-4"
                    >
                        RTP ACCOUNT LOGIN
                    </H1Text>
                    <Hr />
                    <div className="px-1 px-md-4 mt-2">
                        <FlexContainer
                            flexDirection="column"
                        >
                        <form onSubmit={handleSubmit(onSubmit)}>
                            {!mobileAuthentication && (
                            <>
                                <LabelText style={{ color: 'black' }} className="mt-4 mb-2">
                                    Enter your phone number
                                </LabelText>
                                <InputWrapper 
                                    className="row" 
                                    display="flex" 
                                    marginTop="8px" 
                                    borderRadius="4px" 
                                    style={{
                                    ...customInputStyle,
                                    }}
                                >
                                    <Controller
                                    defaultValue={{ value: '+1' }}
                                    color={errors.countryCallingCode ? "red" : "inherit"}
                                    marginBottom="0px"
                                    control={control}
                                    name="countryCallingCode"
                                    placeholder="select"
                                    rules={{
                                      required: 'Calling Code is required'
                                    }}
                                    as={<Select
                                        menuPlacement="auto"
                                        getOptionLabel={(option) => option.value}
                                        styles={phoneCustomStyles}
                                        options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />}
                                    />
                                    <Controller
                                    className="col"
                                    defaultValue={""}
                                    color={errors.phone ? "red" : "inherit"}
                                    border="0px !important"
                                    marginBottom="0px"
                                    marginTop="0px"
                                    marginLeft="0px"
                                    paddingRight="0"
                                    control={control}
                                    name="phone"
                                    rules={{
                                        required: 'This field is required',
                                        validate: isPhoneNumberValidate
                                    }}
                                    as={<NumberFormat
                                        type="tel"
                                        allowNegative={false}
                                        decimalScale={0}
                                        borderRadius="none"
                                        style={{
                                        ...customInputStyle,
                                        height: '39px',
                                        }}
                                    />}
                                    placeholder="Enter phone number"
                                    customInput={Input}
                                    />
                                </InputWrapper>
                                <ErrorMessage
                                    errors={errors}
                                    name="phone"
                                    render={({ message }) => (
                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="countryCallingCode"
                                    render={({ message }) => (
                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                />
                            </>
                            )}
                            {mobileAuthentication && (
                            <>  
                                <div className="mb-3 mt-3">
                                    <Text fontSize="15px" marginTop="8px" marginBottom="10px">
                                        Enter the code you received from the registered mobile to login.
                                    </Text>
                                </div>
                                <InputWrapper style={{ borderColor: '#CCCCCC' }} marginBottom="0px" borderRadius="4px" width='298px'>
                                    <Controller
                                        defaultValue={""}
                                        control={control}
                                        color={errors.newpin ? "red" : "inherit"}
                                        border="0px !important"
                                        name="newpin"
                                        placeholder="Enter Pin"
                                        rules={{
                                            required: 'Pin is required',
                                            pattern: {
                                                value: /^[a-zA-Z0-9]{6}$/,
                                                message: 'Pin must be exactly 6 digits'
                                            }
                                        }}
                                        as={<Input
                                            style={customInputStylePin}
                                            type={showPassword ? "text" : "password"} />}
                                    />
                                    <Img verticalAlign='middle' onClick={() => setShowPassword(!showPassword)} src={showPassword ? OpenIcon : HiddenIcon} />
                                </InputWrapper>
                                <ErrorMessage
                                    errors={errors}
                                    name="newpin"
                                    render={({ message }) => (
                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                />
                            </>
                            )}
                            <div className="mt-2">
                                <SubmitButton
                                    type="submit"
                                    style={{ width: '292px' }}
                                >
                                    Submit
                                </SubmitButton>
                            </div>
                            {errorMessage && <PaymentError header={errorMessage} message={null} />}
                        </form>
                        </FlexContainer>
                    </div>
                </FlexContainer>
            </>
        } />
    )
};

export default Login;
